import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { PipelineLicenseCategoryDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-pipeline-license-category-container',
  templateUrl: './pipeline-license-category-container.component.html',
  styleUrls: ['./pipeline-license-category-container.component.scss']
})
export class PipelineLicenseCategoryContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  pipelinelicensecategorys$: Observable<PipelineLicenseCategoryDto[]>;
  loading: boolean;
  isLoading$:  Observable<any>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("PipelineLicenseCategory");
    this.pipelinelicensecategorys$ = this.gatwayFacade.loadGateway("PipelineLicenseCategory");
    this.pipelinelicensecategorys$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeletePipelineLicenseCategory(deletedValue: any) {
    this.gatwayFacade.remove("PipelineLicenseCategory", deletedValue);
    // this.store.dispatch(PipelineLicenseCategoryStoreActions.removePipelineLicenseCategory({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitPipelineLicenseCategory(formValue: any) {
    console.log("form value: ", formValue);
    formValue.PipelineLicenseCategorys = formValue.PipelineLicenseCategorys.reverse();
    event.preventDefault();
    const pullData = formValue.PipelineLicenseCategorys;
    //const newPullData = formValue.PipelineLicenseCategoryes;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllPipelineLicenseCategory = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllPipelineLicenseCategory.push(pullData[i]);
    }
  }

// check if the addAllPipelineLicenseCategory array is not empty, then dispatch the data to the store
   if(addAllPipelineLicenseCategory.length !== 0) {
    this.gatwayFacade.add('PipelineLicenseCategory', addAllPipelineLicenseCategory);
    // this.store.dispatch(PipelineLicenseCategoryStoreActions.addPipelineLicenseCategory({newPipelineLicenseCategory: addAllPipelineLicenseCategory}));

   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('PipelineLicenseCategory', allUpdates, ['id']);
    // this.store.dispatch(PipelineLicenseCategoryStoreActions.updatePipelineLicenseCategory({updatePipelineLicenseCategory: allUpdates}));
    this.notificationService.success('Saved Successfully');

}
   }

}
